<script>
	import { Basket } from "../lib/stores/basket";
	import { useParams } from "svelte-navigator";
	import { track } from 'fbq';
	const params = useParams();


	let order;
	let order_id;
	Basket.subscribe(b => {
		const urlParams = new URLSearchParams(window.location.search);
		
		if($params && $params.id)
		order_id = $params.id;
		else
		order_id = b.order_id;
		fetch(`https://crm.lamara.in/products/products/getorderbyid?order_id=${order_id}`).then(res => res.json()).then(res => {
			if(!res.error){
				order = res.data;
				if(urlParams.get('payment-success')){
					track('Purchase', {...order, currency: "INR", value: order.order_payment_details.Amount, content_type: 'product', value: order.order_info.total_amount, contents: order.order_product_details.map(item => {
						return {
							...item,
							id: item.item_name,
        					quantity: item.quantity
						}
					})})
				}
			}
		})
	})
	
</script>
{#if order && order.order_info}
	<h4 class="my-4">
		{#if order.order_info.Order_status == "Enquiry (Not Confirmed)"}
			Payment
		{:else}
			{order.order_info.Order_status}
		{/if}
	</h4>
	<div class="row">
		<div class="col">
			<div class="row order-details">
				<div class="col">Name</div>
				<div class="col">{order.order_info.customer_name}</div>
			</div>
			<div class="row order-details">
				<div class="col">Phone</div>
				<div class="col">{order.order_info.phone}</div>
			</div>
			<div class="row order-details">
				<div class="col">Email</div>
				<div class="col">{order.order_info.email}</div>
			</div>
			<div class="row order-details">
				<div class="col">Address</div>
				<div class="col">{order.order_info.address}</div>
			</div>
			<div class="row order-details">
				<div class="col">Delivery date/time</div>
				<div class="col">{order.order_info.delivery_date} {order.order_info.delivery_time}</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col">Order ID</div>
		<div class="col">{order.order_info.order_booking_id}</div>
	</div>
	<div class="table-responsive order-table">
		<table class="table">
			<tr>
				<th>Name</th>
				<th>Size</th>
				<th>Quantity</th>
				<th>Rack Rate</th>
				<th>Tax</th>
				{#if order.order_info.total_discount != "0"}
					<th>Discount</th>
				{/if}
			</tr>
			{#each order.order_product_details as item}
				<tr>
					<td>
						{item.item_name}
					</td>
					<td>
						{item.size}
					</td>
					<td>
						{item.quantity}
					</td>
					<td>{item.rackrate}</td>
					<td>{item.tax}</td>
					{#if order.order_info.total_discount != "0"}
						<td>{item.discount}</td>
					{/if}
				</tr>
			{/each}
		</table>
	</div>
	<h4 class="total-amount">Total: {order.order_info.total_amount}</h4>
	{#if order.order_info.total_discount != "0"}
		<h5 class="font-gray-dark">Discount: {order.order_info.total_discount}</h5>
	{/if}



	{#if order.order_info.Order_status == "Enquiry (Not Confirmed)"}
		<div class="row">
			<div class="col-12"><a class="btn btn-primary" href="{order.order_info.payment_link}?ord_id={order_id}">Proceed to Pay Rs.{order.order_info.total_payamount}</a></div>
			<div class="col-12 mt-2"><small>Do Not Close this window (or click the back button) on processing payment till a successful message is displayed</small></div>
		</div>
	{:else}
		<h4 class="total-paid">Paid: {order.order_payment_details.Amount}</h4>
		<p>Transaction ID: {order.order_payment_details.MerchantRefNo}</p>
		<p>Order details have been sent to your email {order.order_info.email}</p>
	{/if}
{/if}

<style>

	.order-details {
		margin-bottom: 20px;
		font-family: var(--primary-font);
	}

	.order-table {
		margin: 30px 0;
		font-family: var(--primary-font);
	}

	.total-amount {
		font-family: var(--primary-font);
		color: #434343;
		font-weight: 600;
		font-size: 20px;
	}

	.total-paid {
		font-family: var(--primary-font);
		font-weight: 600;
		font-size: 20px;
		margin-bottom: 24px;
	}
	
	.my-4 {
		color: #434343;
	}

	.font-gray-dark {
		color: #434343;
	}
</style>